import { Pipe, PipeTransform } from '@angular/core';

import { TrailerTemps } from '@asset-solutions/customer-portal/orders/models';

@Pipe({
  name: 'sensorDeviation',
  standalone: true
})
export class SensorDeviationPipe implements PipeTransform {
  transform(summary: TrailerTemps, sensor: SensorString): boolean {
    return summary[sensor] > summary.tempMax || summary[sensor] < summary.tempMin;
  }
}

type SensorString = 'sensor1' | 'sensor2' | 'sensor3' | 'returnAir1' | 'returnAir2' | 'returnAir3';
